import { render, staticRenderFns } from "./BiddingReportsPage.vue?vue&type=template&id=ef823026&scoped=true&"
import script from "./BiddingReportsPage.vue?vue&type=script&lang=js&"
export * from "./BiddingReportsPage.vue?vue&type=script&lang=js&"
import style0 from "./BiddingReportsPage.vue?vue&type=style&index=0&id=ef823026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef823026",
  null
  
)

export default component.exports